import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Header = ({ setPage, page }) => {
  const navigate = useNavigate();
  const currentURL = window.location.href;
  console.log(currentURL);

  return (
    <div className="header">
      <h1>TELEMETRYLAB</h1>

      {currentURL === "https://telemetrylab.io/" && (
        <button
          className="landing-page-button"
          onClick={() => {
            navigate("/login");
            setPage("login");
          }}
        >
          Log In
        </button>
      )}
    </div>
  );
};

export default Header;
